import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeNavigation = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Navigation" open={false}>
        <VariantBuilderSetting
          object={variant}
          label="Background Color"
          setting_name="[options][nav-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-background-color"]
              ? variant.options["nav-background-color"]
              : undefined
          }
          placeholder="Transparent"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Style"
          setting_name="[options][nav-border-style]"
          setting_type="border_style"
          object_type="variants"
          value={
            variant.options["nav-border-style"]
              ? variant.options["nav-border-style"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Color"
          setting_name="[options][nav-border-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-border-color"]
              ? variant.options["nav-border-color"]
              : undefined
          }
          placeholder="#000"
          condition={["dotted", "dashed", "solid"].includes(
            variant.options["nav-border-style"]
          )}
          show_reset={true}
          gradient={true}
        />

        {variant.options["nav-border-style"] &&
          variant.options["nav-border-style"] !== "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                  <p className="field-title">Border Width</p>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][nav-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={variant}
                        setting_name={settingName}
                        setting_type="number"
                        object_type="variants"
                        value={
                          _.isNil(
                            variant.options[`nav-border-width-${side}`]
                          ) == false
                            ? variant.options[`nav-border-width-${side}`]
                            : undefined
                        }
                        placeholder="0px"
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={variant}
          label="Corner Radius"
          setting_name="[options][nav-border-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: 'cf-not-rounded',
            some: 'cf-slightly-rounded',
            full: 'cf-fully-rounded',
            custom: 'custom',
          }}
          object_type="variants"
          value={
            variant.options["nav-border-radius"]
              ? variant.options["nav-border-radius"]
              : undefined
          }
          show_reset={true}
        />

        {variant.options["nav-border-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][nav-border-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      _.isNil(
                        variant.options[`nav-border-radius-${side}`]
                      ) == false
                        ? variant.options[`nav-border-radius-${side}`]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder="0px"
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          label="Links Layout"
          setting_name="[options][nav-links-layout]"
          setting_type="layout"
          object_type="variants"
          value={
            variant.options["nav-links-layout"]
              ? variant.options["nav-links-layout"]
              : "horizontal"
          }
          valueMappings={{
            responsive: "horizontal",
            stacked: "vertical",
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Spacing"
          setting_name="[options][nav-links-spacing]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["nav-links-spacing"]
              ? variant.options["nav-links-spacing"]
              : undefined
          }
          placeholder={25}
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Spacing"
          setting_name="[options][nav-links-spacing-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["nav-links-spacing-mobile"]
              ? variant.options["nav-links-spacing-mobile"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-spacing"]
              ? variant.options["nav-links-spacing"]
              : 25
          }
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Font Family"
          setting_name="[options][nav-links-font-family]"
          setting_type="select"
          object_type="variants"
          value={
            variant.options["nav-links-font-family"]
              ? variant.options["nav-links-font-family"]
              : undefined
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            {
              value: "",
              text: "Theme font",
              group: "System fonts",
            },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][nav-links-font-weight]"
          setting_type="font_weight"
          label="Weight"
          object_type="variants"
          value={
            variant.options["nav-links-font-weight"]
              ? variant.options["nav-links-font-weight"]
              : undefined
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Font Size"
          setting_name="[options][nav-links-font-size]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["nav-links-font-size"]
              ? variant.options["nav-links-font-size"]
              : undefined
          }
          placeholder={16}
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Font Size"
          setting_name="[options][nav-links-font-size-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["nav-links-font-size-mobile"]
              ? variant.options["nav-links-font-size-mobile"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-font-size"]
              ? variant.options["nav-links-font-size"]
              : 16
          }
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Font Color"
          setting_name="[options][nav-links-font-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-links-font-color"]
              ? variant.options["nav-links-font-color"]
              : undefined
          }
          placeholder="#000"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Links Hover Color"
          setting_name="[options][nav-links-hover-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-links-hover-color"]
              ? variant.options["nav-links-hover-color"]
              : undefined
          }
          placeholder="#000"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Hamburger menu on mobile"
          setting_name="[options][nav-hamburger]"
          setting_type="checkbox"
          object_type="variants"
          value={
            variant.options["nav-hamburger"]
              ? variant.options["nav-hamburger"]
              : "true"
          }
          device="mobile"
        />

        <VariantBuilderSetting
          object={variant}
          label="Hamburger Icon Color"
          setting_name="[options][nav-hamburger-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-hamburger-color"]
              ? variant.options["nav-hamburger-color"]
              : undefined
          }
          placeholder="#000"
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Menu Background Color"
          setting_name="[options][nav-menu-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["nav-menu-background-color"]
              ? variant.options["nav-menu-background-color"]
              : undefined
          }
          placeholder="Transparent"
          device="mobile"
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeNavigation;
